var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.93262,
    width: 1.31881,
    height: 18.2936,
    rx: 0.659407,
    transform: "rotate(-45 3 3.93262)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9355,
    y: 3,
    width: 1.31881,
    height: 18.2936,
    rx: 0.659407,
    transform: "rotate(45 15.9355 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.a8450242b314bbef7cf3bb2464f9b231.svg";
export { ForwardRef as ReactComponent };